"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stock = void 0;
var utils_1 = require("../../utils");
exports.stock = function (axios) {
    return {
        postStocks: function (request) {
            return axios.post('/stocks', request.data);
        },
        postStocksAdjust: function (request) {
            return axios.post('/stocks/adjust', request.data);
        },
        postStocksEdit: function (request) {
            return axios.post('/stocks/edit', request.data);
        },
        putStocksExcel: function (request) {
            return axios.put('/stocks/excel', request.data, { responseType: 'arraybuffer' });
        },
        putStocksExcelJsonType: function (request) {
            return axios.put('/stocks/excel', request.data);
        },
        postStocksSoldOut: function (request) {
            return axios.post('/stocks/sold-out', request.data);
        },
        getStocksStockNoChangeHistories: function (request) {
            var url = utils_1.paramPathchange('/stocks/{stockNo}/change-histories', request);
            return axios.get(url, request);
        },
        getStocksExcelFailResult: function (request) {
            return axios.get("/stocks/excel/fail-result/" + request.pathParams.stockFailNo, { responseType: 'arraybuffer' });
        },
    };
};
